import { createContext, useContext, useReducer } from "react";
import { userReducer } from "./UserReducer" 
import { User } from "models/User"
import { UserStateModel, initialUserState } from "models/UserState"

type Props = {
  children: React.ReactNode;
};

const UserContext = createContext<{stateUser: UserStateModel}>({stateUser: initialUserState});

const UserProvider = ({ children }: Props) => {

  const [stateUser, dispatch] = useReducer(userReducer, initialUserState)
  
  stateUser.addUser = (user : User): void => {
    dispatch({ type: "set_user", user: user });
  };

  stateUser.updateUser = (user : User): void => {
    dispatch({ type: "update_user", user: user });
  }

  return (<UserContext.Provider value={{stateUser}}>{children}</UserContext.Provider>);
};

export default UserProvider;

export const UserState = () =>{
    return useContext(UserContext);
}